// extracted by mini-css-extract-plugin
module.exports = {"root":"Services-module--root--16ySB","wrapper":"Services-module--wrapper--10Kta","image":"Services-module--image--36PCF","content":"Services-module--content--ZEHuP"};